import { pageTitle } from 'ember-page-title';
import GithubIcon from '~icons/fa7-brands/github';
import MastodonIcon from '~icons/fa7-brands/mastodon';
import BlueskyIcon from '~icons/fa7-brands/bluesky';

<template>
  {{pageTitle "Home"}}
  <div class="w-full my-24 text-center text-5xl animate-text-color-shift">
    <span>tcjr</span><span>.</span><span>org</span>
  </div>

  <div class="w-full flex flex-row justify-center gap-6 text-sm">
    <a
      class="text-gray-50 hover:text-yellow-200 hover:scale-110 transition-all"
      rel="me"
      href="https://bsky.app/profile/tcjr.org"
    >
      {{! <FaIcon @icon="bluesky" @prefix="fab" @size="3x" /> }}
      <BlueskyIcon class="h-8 w-8" />
    </a>

    <a
      class="text-gray-50 hover:text-yellow-200 hover:scale-110 transition-all"
      rel="me"
      href="https://indieweb.social/@tommyjr"
    >
      {{! <FaIcon @icon="mastodon" @prefix="fab" @size="3x" /> }}
      <MastodonIcon class="h-8 w-8" />
    </a>

    <a
      class="text-gray-50 hover:text-yellow-200 hover:scale-110 transition-all"
      href="https://github.com/tcjr"
    >
      <GithubIcon class="h-8 w-8" />
    </a>
  </div>

  <footer class="mt-48 text-blue-800 text-xs">
    <span>©2023 tcjr</span>
  </footer>
</template>
